import TitleHeader from "@standard/components/TitleHeader";
import JobUploadForm from "./JobUploadForm";
import JobUploadTable from "./JobUploadTable";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const programType = "Transaction";
const programName = "Job Upload";
const url = "transaction/jobupload";

export default function ({ history }) {
  const { path } = useRouteMatch();

  return (
    <>
      <TitleHeader programName={programName} programType={programType} />
      <Switch>
        <Route exact path={path}>
          <JobUploadTable url={url} />
        </Route>
        <Route path={`${path}/:action/:id?`}>
          <JobUploadForm history={history} url={url} />
        </Route>
      </Switch>
    </>
  );
}
